import { API } from 'shared/utils/apiMiddleware';
import { BILLINGS_API_NAME, ACCOUNTS_MANAGEMENT_ROOT } from './helperFunctions';
import { hashText } from '~/shared/utils/strUtil.js';


const managementRoute = `${ACCOUNTS_MANAGEMENT_ROOT}/management`;

export const fetchManagementAccounts = async () => API.get('billings', managementRoute);

export const updateAccountProperties = async (data) => API.put('billings', `${managementRoute}/${data.id}/properties`, { body: data });

export async function fetchPayerLinkedAccounts(payerId) {
  const data = await API.get(
    BILLINGS_API_NAME,
    `${managementRoute}/${payerId}/linked-accounts`,
  );
  const externalId = await hashText(payerId, 8);
  return data.map((rla) => {
    rla.externalId = externalId;
    return rla;
  });
}

export async function updateLinkedAccountData({ payerAccountId, linkedAccountId, linkedAccountData }) {
  const payload = {
    body: { linkedAccountData },
  };
  const encodedPayerAccountId = encodeURIComponent(payerAccountId);
  const encodedLinkedAccountId = encodeURIComponent(linkedAccountId);

  return API.put(
    BILLINGS_API_NAME,
    `${managementRoute}/${encodedPayerAccountId}/linked-accounts/${encodedLinkedAccountId}`,
    payload,
  );
}

export async function validateLinkedAccounts(linkedAccounts) {
  const payload = {
    body: { linkedAccounts },
  };
  return API.put(BILLINGS_API_NAME, `${managementRoute}/linked-accounts/validate`, payload);
}

export async function deleteAccount({ id }) {
  return API.del(BILLINGS_API_NAME, `${managementRoute}/${id}`)
}
